// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"0cec7dbb","297":"bdbdb3d3","643":"fe9ebcb2","959":"3e139f96"}[chunkId] + ".chunk.js";
};